import SelectTree from 'components/SelectTree';
import React from 'react';

class SelectTreeFilter extends React.Component<any, any> {
  state = { data: [] as any };
  onChange = (selecteds: any) => {
    if (this.props.onChange) {
      let products: any = [];
      selecteds.forEach((item: any) => {
        let prod = this.props.options.find((currProd: any) => currProd.id === item.id);
        if (this.props.itemLabel) {
          prod.label = prod[this.props.itemLabel];
        }
        if (this.props.itemValue) {
          prod.value = prod[this.props.itemValue];
        }
        products.push(prod);
        if (Array.isArray(item._children) && item._children.length) {
          item._children.forEach((childId: any) => {
            let child = this.props.options.find((currProd: any) => currProd.id === childId);
            let newChild: any = {};
            newChild.label = child[this.props.itemLabel];
            newChild.value = child[this.props.itemValue];
            products.push(newChild);
          });
        }
      });
      this.props.onChange(products);
    }
  };
  uncheckAll = () => {
    const data = this.state.data;
    data[0].checked = false;
    this.setState({ data });
  };

  componentDidUpdate(prevProps: any) {
    if (prevProps.options !== this.props.options) {
      this.convertServiceFormatToComponent(this.props.options);
    }
    if (prevProps.cleanInput !== this.props.cleanInput && this.props.cleanInput) {
      this.uncheckAll();
    }
  }
  convertServiceFormatToComponent(options: any) {
    if (options && Array.isArray(options)) {
      let data: any = [];
      options.forEach((item: any) => {
        let newItem: any = {};
        newItem.label = `${item.id} - ${item.title}`;
        newItem.value = item.id;
        newItem.id = item.id;
        if (!item.parent_id) {
          newItem.children = [];
          const variations = options.filter((prod: any) => prod.parent_id === item.id);
          if (variations) {
            variations.forEach((vari: any) => {
              let newVar: any = {};
              newVar.label = `${vari.id} - ${vari.title}`;
              newVar.value = vari.id;
              newVar.id = vari.id;
              data.push(newVar);
            });
          }
          data.push(newItem);
        } else {
          const existFather = options.find((prod: any) => prod.id === item.parent_id);
          if (!existFather) {
            data.push(newItem);
          }
        }
      });
      this.setState({ data });
    }
  }

  render() {
    return (
      <SelectTree
        loading={this.props.loading}
        onChange={this.onChange}
        placeholder={this.props.placeholder ? this.props.placeholder : 'Selecione os produtos'}
        data={this.state.data}
        clear={this.props.clearInput}
      />
    );
  }
}
export default SelectTreeFilter;
